<!--
	Created by lwy in 2020/4/22.
-->
<template>
  <div>
    <!--    页脚-->
    <div class="Footerwrap xcenter">
      <div class=" colorF XYcenter" style="margin-top: 70px">
        <div class="pointer  marTop5">
          <img src="../img/logo.png" alt="">
        </div>
        <div class="marLeft20 marRight20 size18">|</div>
        <div class="size14">{{$t('page.global_logistics_tracking_platform')}}</div>
      </div>
      <div style="width: 814px;" class="textCenter marTop30 color99 size14">{{$t('page.pagefooter_a')}}</div>
      <div class="marTop30 flex" style="width: 1000px;height: 40px">
        <!--        <el-input class="marRight20" placeholder="您的联系方式"></el-input>-->
        <!--        <el-input class="marRight20" placeholder="您的联系邮箱"></el-input>-->
        <!--        <el-button type="primary">提交</el-button>-->
      </div>
      <el-row style="width: 1000px;" class="marTop40" type="flex" justify="space-between">
        <div>
          <el-row class="color99 size14">
            <i class="iconfont icondianhua marRight5"></i>
            <span>{{$t('page.pagefooter_b')}}：13318752838</span>
          </el-row>
          <el-row class="color99 size14 marTop20">
            <i class="iconfont iconqiyeyouxiang marRight5"></i>
            <span>{{$t('page.pagefooter_c')}}：service@vesaas.com</span>
          </el-row>
          <el-row class="color99 size14 marTop20">
            <i class="iconfont iconweizhidingwei marRight5"></i>
            <span>{{$t('page.pagefooter_d')}}</span>
          </el-row>
        </div>
        <div class="color99 size32 paddTop20 social-share no-user-select" id="socialShare" data-initialized="true">
          <a class="icon-qq social-share-icon"><i class="iconfont iconsign_qq marRight20 pointer iHover transition3ms"></i></a>
          <el-popover
            placement="top"
            width="240"
            trigger="hover">
            <div>
              <div class="weixin-head">
                <span class="weixin-title displayIB">{{$t('page.pagefooter_e')}}</span>
                <!--<i class="close displayIB pointer">x</i>-->
              </div>
              <div class="weixin-qr">
                <img src="../img/weixin-qr.png"/>
              </div>
              <p class="paddLeft10 size12">{{$t('page.pagefooter_f')}}</p>
              <p class="paddLeft10 size12">{{$t('page.pagefooter_g')}}</p>
            </div>
            <i slot="reference" class="iconfont iconweixin-copy marRight20 pointer iHover transition3ms" @click="isShow=true"></i>
          </el-popover>
          <a class="icon-weibo social-share-icon"><i class="iconfont iconweibo marRight20 pointer iHover transition3ms"></i></a>
          <a class="icon-douban social-share-icon"><i class="iconfont icondouban marRight20 pointer iHover transition3ms"></i></a>
          <a class="icon-facebook social-share-icon"><i class="iconfont iconFacebook marRight20 pointer iHover transition3ms"></i></a>
          <a class="icon-twitter social-share-icon"><i class="iconfont iconTwitter marRight20 pointer iHover transition3ms"></i></a>
        </div>
      </el-row>
      <div class="copyright XYcenter">
        <div class="foot">© 2019 https://trackingyee.com {{$t('page.Copyright')}}<a href="http://www.beian.miit.gov.cn" target="_blank" class="color99">粤ICP备16014160号-7</a></div>
      </div>
    </div>
  </div>
</template>

<script>
  import socialShare from 'social-share.js/dist/js/social-share.min';

  export default {
    data() {
      return {
        isShow: false
      }
    },
    methods: {  //方法
      clickout() {
        if (this.isShow) {
          this.isShow = false
        }
      }
    },
    directives: {
      clickoutside: {
        bind(el, binding) {
          const documentHandler = (e) => {
            if (el.contains(e.target)) return

            binding.value(e)
          }
          el.__vueClickOutside__ = documentHandler
          document.addEventListener('click', documentHandler)
        },
        /**
         * 更新方法
         */
        update() {

        },
        /**
         * 销毁方法
         * @param {Object} el - The element the directive is bound to.
         */
        unbind(el) {
          document.removeEventListener('click', el.__vueClickOutside__)
          delete el.__vueClickOutside__
        },
      }
    },
    created() {//created 创建完毕状态

    },
    mounted() {//mounted 挂载结束状态
      window.socialShare('#socialShare', {
        // 这里配置各种参数
        url: 'https://trackingyee.com/', // 网址，默认使用
        // source              : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: document.title, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: '智能化监控运单，多维度时效分析，您值得信赖的物流管家！留下你的联系方式，让我们马上为您服务吧！', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: 'https://vesaas.com/_nuxt/img/c86b8b5.png', // 图片, 默认取网页中第一个img标签
        sites: ['qq', 'qzone', 'weibo', 'douban', 'facebook', 'twitter'], // 启用的站点
        disabled: ['google'] // 禁用的站点
      })
    }

  }
</script>

<style scoped>
  .relative{position: relative}
  .Footerwrap {
    height: 538px;
    background: url("../img/footer.png");
    background-size: cover;
  }

  .marRight5 {
    margin-right: 5px;
  }

  .copyright {
    height: 60px;
    border-top: 1px solid #666;
    width: 100%;
    margin-top: 100px;
  }

  .foot {
    width: 100%;
    text-align: center;
    color: #999999 !important;
    font-size: 12px;
  }

  >>> .social-share-icon {
    color: #999;
  }

  .weixin {
    background: #fff;
    border: solid 1px #d8d8d8;
    z-index: 11001;
    font-size: 12px;
    left: -112px;
    bottom: 60px;
    width: 240px;
    padding: 10px;
    height: 288px;
    position: absolute;
  }

  .weixin-head {
    font-size: 12px;
    font-weight: bold;
    text-align: left;
    line-height: 16px;
    height: 16px;
    position: relative;
    color: #000;
  }

  .weixin-title {
    font-size: 12px;
    font-weight: bold;
  }

  .close {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 0;
    top: 0;
    color: #999;
    text-decoration: none;
    font-size: 16px;
  }

  .weixin-qr {
    margin: 20px auto;
    text-align: center;
  }

  .weixin-qr img {
    vertical-align: middle;
    width: 81%;
  }
</style>



// WEBPACK FOOTER //
// src/page/pagefooter.vue